import script from "./CandidatesModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./CandidatesModal.vue?vue&type=script&setup=true&lang=ts"

import "./CandidatesModal.vue?vue&type=style&index=0&id=09df5d68&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-09df5d68"]])

export default __exports__